"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/datalake-tape/types");
Object.defineProperty(exports, "artifactType", { enumerable: true, get: function () { return types_1.artifactType; } });
exports.NodeConfigSchema = types_1.IntermediateRecordConfigSchema;
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    type: zod_1.z.literal(types_1.artifactType),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map